module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_5010.1cafaed8.png";